<template>
  <td :class="{ 'is-router-link': !!routeLocation, 'is-action': !!action, nowrap: nowrap }" :colspan="colspan">
    <template v-if="routeLocation">
      <component :is="linkComponent" :to="routeLocation">
        <slot />
      </component>
    </template>
    <template v-else>
      <slot />
    </template>
  </td>
</template>

<script setup lang="ts">
import { inject } from 'vue'

import { APP_TABLE_ROW_ROUTE_LOCATION, APP_LINK_COMPONENT, type RouteLocation } from './app-table.keys'

const props = defineProps<{
  routeLocation?: RouteLocation
  colspan?: string
  action?: boolean
  nowrap?: boolean
}>()

const linkComponent = inject(APP_LINK_COMPONENT, undefined)

const routeLocation =
  !props.action && linkComponent
    ? (props.routeLocation ?? inject(APP_TABLE_ROW_ROUTE_LOCATION, props.routeLocation))
    : undefined
</script>

<style lang="scss" scoped>
td {
  height: 47px;
  padding: 0 16px;
  color: var(--color-fg-default);

  &.is-router-link {
    padding: 0;

    > a {
      padding: 0 16px;
      display: flex;
      align-items: center;
      width: 100%;
      height: 100%;
      text-decoration: inherit;
      color: inherit;
    }
  }

  &:not(.is-router-link) {
    > a {
      text-decoration: none;
      font-weight: 500;
      color: var(--color-accent-fg);

      &:hover {
        text-decoration: underline;
      }
    }
  }

  &.is-action {
    width: 1px;
  }

  &.nowrap {
    white-space: nowrap;
  }
}
</style>
